/** @format */

import { AsyncPipe, NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import {
	FulfillmentButtonInterface,
	selectShipMode,
	selectShipToMeButtonText
} from '@pdp/add-to-cart/data-access';

import { ChangeZipCodeButtonComponent } from '../../../change-zip-code-button/change-zip-code-button.component';
import { CommonTimerComponent } from '@shared/components';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectBundleShipToMeButtonText } from '@pdp/data-access/state';
import { selectHomrScheduleContent } from '@state/data-access';

@Component({
	selector: 'pdp-feature-ship-to-me-subtext',
	templateUrl: './ship-to-me-subtext.component.html',
	styleUrl: './ship-to-me-subtext.component.scss',
	imports: [NgClass, ChangeZipCodeButtonComponent, CommonTimerComponent, AsyncPipe]
})
export class ShipToMeSubtextComponent implements OnInit {
	@Input() isBundle = false;

	shipMode$ = this.store.select(selectShipMode);

	shipToMeButtonText$: Observable<FulfillmentButtonInterface>;

	GTGTHomrScheduleContent$ = this.store.select(selectHomrScheduleContent);

	timerRunning = true;

	constructor(private store: Store) {}

	ngOnInit(): void {
		this.shipToMeButtonText$ = this.getShipToMeButtonTextSelector();
	}

	getShipToMeButtonTextSelector(): Observable<FulfillmentButtonInterface> {
		return this.isBundle
			? this.store.select(selectBundleShipToMeButtonText)
			: this.store.select(selectShipToMeButtonText);
	}
}
